import { render, staticRenderFns } from "./CodaPreview.vue?vue&type=template&id=b11b1788&scoped=true"
import script from "./CodaPreview.vue?vue&type=script&lang=ts"
export * from "./CodaPreview.vue?vue&type=script&lang=ts"
import style0 from "./CodaPreview.vue?vue&type=style&index=0&id=b11b1788&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11b1788",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b11b1788')) {
      api.createRecord('b11b1788', component.options)
    } else {
      api.reload('b11b1788', component.options)
    }
    module.hot.accept("./CodaPreview.vue?vue&type=template&id=b11b1788&scoped=true", function () {
      api.rerender('b11b1788', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bank/CodaPreview.vue"
export default component.exports